import { Box, SxProps } from "@mui/material";
import { FC, useContext } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { v4 } from "uuid";
import { useAppSelector } from "../../store/hooks";
import store from "../../store/store";
import { submitForm } from "../../store/submit-form-slice";
import { buildRow, componentConfiguration } from "../model/field-configuration";
import { transformFormData } from "../model/form-submit";
import PPSection from "./PPSection";
import { ListViewContext } from "../../context/ApplicationContext";

const style: SxProps = {
  padding: 1,
};

const PPForm: FC<{
  setDialogState: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ setDialogState }) => {
  const lstContext = useContext(ListViewContext);
  const methods = useForm({ defaultValues: {} });
  const { form } = useAppSelector((state) => state.form);

  let [queryParams] = useSearchParams();

  const onSubmit: SubmitHandler<any> = (data: any, e: React.BaseSyntheticEvent | undefined) => {
    //console.log(JSON.stringify(transformFormData(data, form, queryParams)));
    setDialogState(true);
    store.dispatch(
      submitForm(
        queryParams,
        transformFormData(data, form, queryParams, lstContext),
        methods.reset
      )
    );
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={ e => { e.preventDefault(); return methods.handleSubmit(onSubmit)}}>
        <Box key={'box'} sx={{ ...style }}>
          {[...form.sections]
            .sort((a, b) => a.order - b.order)
            .map((section) => {
              return (
                <PPSection key={section.id} show={true} section={section}>
                  {componentConfiguration(section).map(buildRow)}
                </PPSection>
              );
            })}
        </Box>
      </form>
    </FormProvider>
  );
};

export default PPForm;
//PPForm.whyDidYouRender = true;
